import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react";
import CareGiverStore from "../../Store/CareGiverStore";
import { NurseAndCareGiverURL } from "../../Url/Url";
import axios from "axios";
import AgencyStore from "../../Store/AgencyStore";
import FormikController from "../../components/FormikController/FormikController";
import { leftStyles, centerStyles } from "../../Constants/Constants";
import {
  CellRenderer,
  dateCellRenderer,
  notificationCellRenderer,
  useOnGridReady,
} from "../../Utils/AgGridUtils";
import NotificationStore from "../../Store/NotificationStore";
import GlobelStore from "../../Store/GlobelStore";
import NurseAndCareGiverEmployeeStore from "../../Store/NurseAndCareGiverEmployeeStore";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../Agency/PageTitle";
import Icon from "../../components/Icons/Icon";
const Notification = observer(() => {
  const navigate = useNavigate();
  const [onGridReady, onFirstDataRendered] = useOnGridReady(
    NotificationStore,
    "nurseNotificationAgGrid"
  );

  useEffect(() => {
    NurseAndCareGiverEmployeeStore.getEmployeeNotificationEmployeeUser();
  }, []);

  const columnDefs = useMemo(
    () => [
      {
        field: "isViewed",
        headerName: "Status",
        sortable: false,
        width: 10,
        headerClass: "center-header",
        cellStyle: (params) => {
          return centerStyles;
        },
        cellRenderer: (params) => {
          const handleCheckboxChange = (values) => {
            AgencyStore.setIsLoading(true);
            const params = {
              notificationId: values.id,
              isViewed: !values.isViewed,
            };
            axios
              .post(NurseAndCareGiverURL.SET_NOTIFICATION_VIEW, params, {
                headers: { Authorization: localStorage.getItem("loginToken") },
              })
              .then((res) => {
                NurseAndCareGiverEmployeeStore.getEmployeeNotificationEmployeeUser();
                NurseAndCareGiverEmployeeStore.getEmpClientUnseenNotificationCount();

                AgencyStore.setIsLoading(false);
              })
              .catch((err) => {
                AgencyStore.setIsLoading(false);
                AgencyStore.showAlert("error", "Failed to Change statues");
              });
          };

          return (
            <div>
              <input
                type="checkbox"
                onChange={() => handleCheckboxChange(params.data)}
                checked={params.data.isViewed}
              />
            </div>
          );
        },
      },
      {
        field: "title",
        headerName: "Title",
        filter: true,
        width: 70,

        cellStyle: (params) => {
          return leftStyles;
        },
        cellRenderer: notificationCellRenderer,
      },
      {
        field: "description",
        headerName: "Description",
        filter: true,
        cellStyle: (params) => {
          return leftStyles;
        },
        cellRenderer: CellRenderer,
      },

      {
        field: "date",
        headerName: "Date",
        filter: true,
        width: 20,

        cellStyle: (params) => {
          return leftStyles;
        },
        cellRenderer: dateCellRenderer,
      },
    ],
    []
  );

  const getRowStyle = (params) => {
    if (params.data.isViewed === true) {
      return { background: "#DFF0D8" };
    }
    return null;
  };

  return (
    <div>
      <div className="pageHeaderContainer">
        <PageTitle
          icon={<Icon iconName="menu" />}
          headerTitle="Navigation"
          subHeaderTitle="  Navigation/My Notification"
        />
      </div>
      <FormikController
        rowData={NotificationStore?.nurseNotificationAllData?.resultSet}
        control="agGrid"
        columnDefs={columnDefs}
        onGridReady={onGridReady}
        getRowStyle={getRowStyle}
        onFirstDataRendered={onFirstDataRendered}
      />
    </div>
  );
});

export default Notification;
